(function () {

    'use strict';

    angular.module('FotocApp')

        .component('tile', {

            templateUrl: window.BASE_PATH + '/backend/backend/tile.component.html',
            bindings: {
                data: '<',
                editorData: '<',
                details: '<',
                pos: '<', // posicion del frame en el los bounds del layout
                type: '@',
                sin: '@'
            },

            controller: ['$scope', '$editorService', '$canvasService', '$timeout', '$http', '$lang', '$element', function ($scope, $editorService, $canvasService, $timeout, $http, $lang, $element) {

                this.BASE_PATH = window.BASE_PATH;
                this.DIFF_STAPLE = 2;
                this.pos = 0;
                this.rand = 'svg_' + Math.random();

                var self = this;
                self.metric = 'cm';

                this.$onInit = function () {

                    var EDITOR_DATA = self.editorData;

                    var template = CONFIG_DATA[EDITOR_DATA.type].data.layouts[EDITOR_DATA.layout_id].sizes[EDITOR_DATA.layout_size];

                    self.template = template;
                    self.BASE_PATH = window.BASE_PATH;
                    self.bleeding = CONFIG_DATA[EDITOR_DATA.type].config.config.bleeding;
                    self.frame_weight = CONFIG_DATA[EDITOR_DATA.type].config.config.frame_weight;
                    self.size = template.sizes[this.pos];


                    self.hash_composition = EDITOR_DATA.info.model;
                    //self.sin = EDITOR_DATA.sin;

                    var image;
                    if (EDITOR_DATA.group === 1) {
                        image = EDITOR_DATA.images[0];
                    } else {
                        image = EDITOR_DATA.images[self.pos];
                    }

                    self.frameColor = 'transparent';
                    if (typeof EDITOR_DATA.images[self.pos].frameColor == 'undefined' || EDITOR_DATA.images[self.pos].frameColor != 'NONE') {
                        self.frameColor = EDITOR_DATA.images[self.pos].frameColor;
                    }

                    if (image.urlFinalImage !== undefined && image.urlFinalImage.length > 0) {
                        self.image_url = image.urlFinalImage;
                    } else if (image.urlWithFilter.length > 0) {
                        self.image_url = image.urlWithFilter;
                    } else {
                        self.image_url = image.urlWithoutFilter;
                    }

                    var b;
                    if (EDITOR_DATA.group === 1) {
                        b = template.size_group;
                    } else {
                        b = self.size;
                    }

                    var multip;
                    var ex;
                    if (template.size_group[0] > template.size_group[1]) {
                        multip = template.size_group[0] / 1000;
                        ex = 0;
                    } else {
                        multip = template.size_group[1] / 1000;
                        ex = getMinorLeftBound(template.bounds) * multip;
                    }

                    self.x = template.bounds[self.pos][0] * multip;
                    self.y = template.bounds[self.pos][1] * multip;

                    var _x = image.position.x * multip;
                    var _y = image.position.y * multip;


                    self.center = (self.size[0] / 2) + self.bleeding + self.frame_weight;
                    self.centerMark = ((template.size_group[0] / 2) - (self.x) + (ex) + self.bleeding + self.frame_weight);

                    var _scale = image.position.scaleX;
                    var _rotate = image.position.rotation;

                    self.image_pos = {
                        scale: _scale,
                        rotate: _rotate,
                        x: _x,
                        y: _y
                    }


                    if (image.type == "my_galery") {

                        adjuntImageInBound(image.data.originalImageInfo.width, image.data.originalImageInfo.height, b, EDITOR_DATA.type == 'multitiles' ? 'NONE' : image.frameColor);

                    } else {
                        adjuntImageInBound(image.data.assets.large_thumb.width, image.data.assets.large_thumb.height, b, EDITOR_DATA.type == 'multitiles' ? 'NONE' : image.frameColor);
                    }

                };

                this.slice = function ($str, $start, $end) {

                    return String($str).slice($start, $end)

                };

                function getMinorLeftBound(bounds) {

                    var minor = 9999;
                    bounds.forEach(function (b) {

                        if (b[0] < minor) {
                            minor = b[0];
                        }

                    });

                    return minor;
                }


                function adjuntImageInBound($src_w, $src_h, bounds, frameColor) {

                    var ratio = 1;
                    var resize_w;
                    var resize_h;

                    if (($src_w / $src_h) > (bounds[0] / bounds[1])) {

                        resize_h = bounds[1] + ((frameColor == 'NONE' || typeof frameColor == 'undefined') ? self.bleeding * 2 : 0);
                        resize_w = $src_w * resize_h / $src_h;
                        ratio = resize_h / $src_h;
                    } else {

                        resize_w = bounds[0] + ((frameColor == 'NONE' || typeof frameColor == 'undefined') ? self.bleeding * 2 : 0)
                        resize_h = $src_h * resize_w / $src_w;
                        ratio = resize_w / $src_w;

                    }


                    self.image_dim = {
                        w: resize_w,
                        h: resize_h,
                        scale: ratio
                    }


                    return;
                }


            }]


        })

})();